<div class="row" style="padding-bottom: 10px;">
    <div class="col-sm-12">
        <div style="display: flex; align-items: center;">
            <h4 style="margin-top: 7px;">{{ gridTitle }}</h4>
            <mat-icon 
                matTooltipPosition="right" 
                aria-label="Templates Help" 
                [matTooltip]="tooltipContent"
                matTooltipClass="templates_help"
                class="helperContent">help_outline
            </mat-icon>
        </div>
    </div>
</div>
<div class="row pc-pt-wrapper" style="padding-bottom: 20px;">
    <div class="col-12" style="padding: 0;">
        <p-table
            [value]="tableRows"
            dataKey="id"
            [loading]="loading"
            [scrollable]="true"
            scrollHeight="50vh"
            [rowHover]="true"
            sortField="name"
            [sortOrder]="1"
            styleClass="p-datatable-sm pc-template-table">

            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="name">Name <p-sortIcon field="name" /></th>
                    <th pSortableColumn="phases">Phases <p-sortIcon field="phases" /></th>
                    <th pSortableColumn="events">Events <p-sortIcon field="events" /></th>
                    @if (displayHarvestsCreated) {
                        <th pSortableColumn="harvestsCreated">Harvests Created <p-sortIcon field="harvestsCreated" /></th>
                    }
                    <th pSortableColumn="duration">Duration (Days) <p-sortIcon field="duration" /></th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-t>
                <tr class="pc-row" (click)="openTemplate(t)">
                    <td><span class="pc-name-text">{{ t.name }}</span></td>
                    <td>{{ t.phases }}</td>
                    <td>{{ t.events }}</td>
                    @if (displayHarvestsCreated) {
                        <td>{{ t.harvestsCreated }}</td>
                    }
                    <td>{{ t.duration }}</td>
                </tr>
            </ng-template>

            <ng-template pTemplate="footer">
                @if (tableRows.length > 0) {
                    <tr class="pc-footer">
                        <td [attr.colspan]="totalColumnCount" class="pc-footer-label">
                            {{ tableRows.length }} {{ itemNoun }}{{ tableRows.length === 1 ? '' : 's' }}
                        </td>
                    </tr>
                }
            </ng-template>

            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="totalColumnCount" class="pc-empty">
                        {{ loading ? 'Loading ' + itemNoun + 's…' : 'No ' + itemNoun + 's to show.' }}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
